import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'
import { MONITOR_LOCATIONS } from '@/lib/check-locations'

const data = {
  term: 'DNS Propagation',
  slug: 'dns-propagation',
  definition: `DNS propagation is the process by which updated DNS records spread across the global network of DNS servers. When you change a DNS record — such as pointing your domain to a new server — that change does not take effect everywhere instantly.

DNS servers around the world cache records based on the TTL (Time To Live) value. Until the cached record expires, some users will be directed to the old server while others reach the new one. Full propagation typically takes 24 to 48 hours, though most changes are visible within a few hours.

During propagation, your service may appear to work for some users and fail for others. This inconsistent behavior can be confusing to diagnose if you are not aware that DNS changes are still propagating.`,
  whyItMatters: `DNS propagation is a common source of apparent downtime during migrations and infrastructure changes. Understanding propagation helps you plan changes to minimize disruption.

Lowering your TTL well before a migration gives DNS servers less time to cache the old record, speeding up propagation. A TTL of 300 seconds (5 minutes) means most servers will pick up the change within 5 minutes of it going live.`,
  howUptrackHelps: `Uptrack monitors your endpoints ${MONITOR_LOCATIONS.glossary}, so during a DNS migration you can see whether the new server answers everywhere.

By watching response times and status codes during a migration, you can confirm the transition is smooth and detect any issues caused by DNS misconfiguration early.`,
  relatedTerms: [
    { name: 'SSL Certificate', href: '/glossary/ssl-certificate' },
    { name: 'Latency', href: '/glossary/latency' },
    { name: 'Downtime', href: '/glossary/downtime' },
    { name: 'Uptime', href: '/glossary/uptime' },
    { name: 'Check a site from multiple locations', href: '/blog/how-to-check-if-a-website-is-down-from-multiple-locations' },
  ],
}

export const Route = createFileRoute('/_site/glossary/dns-propagation')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
